"use strict";

$.fn.hasAttr = function (name) {
  return this.attr(name) !== undefined;
};
var Profile = {
  resetPasswordSuccessfully: '',
  changePasswordSuccessfully: '',
  autoRedirectAfterSofortCallback: '',
  isSelected: 0,
  onload: document.addEventListener('DOMContentLoaded', function () {
    Profile.init();
  }),
  init: function init() {
    this.bind();
    this.initDataPicker();
    this.resetPasswordSuccess();
    this.changePasswordSuccess();
    this.autoRedirectAfterSofortCallbackFunction();
  },
  bind: function bind() {
    $(document).on('click', '.upload-stripe-docs', function (event) {
      event.preventDefault();
      var block = $(this);
      var parentBlock = block.closest('div.personal-info-form__files');
      var dataType = parentBlock.data('type');
      var $input = $('<input type="file" accept=".png, .jpg, .jpeg, .pdf, .HEIC, .heic">').on('change', function () {
        if (parseInt(parentBlock.data('status')) === 1) {
          Main.showPreloader(block.closest('.personal-info-form__file-name'));
        } else {
          Main.showPreloader(block.next());
        }
        var fileNmame = this.files[0];
        var fileNameExt = fileNmame.name.substr(fileNmame.name.lastIndexOf('.') + 1);
        if (fileNameExt == "heic" || fileNameExt == "HEIC") {
          var thisInput = this;
          heic2any({
            blob: fileNmame,
            toType: "image/jpeg",
            quality: 0.5
          }).then(function (result) {
            var container = new DataTransfer();
            var fileJpeg = new File([result], fileNmame.name + ".jpg", {
              type: "image/jpeg",
              lastModified: new Date().getTime()
            });
            container.items.add(fileJpeg);
            $.each(this.files, function (key, file) {
              Profile.ajax.uploadUserDocument(container.files[0], dataType);
            });
          })["catch"](function (x) {
            // console.log('erro-1', x.code);
            // console.log('erro-2', x.message);
            // console.log('x', x);
          });
        } else {
          $.each(this.files, function (key, file) {
            Profile.ajax.uploadUserDocument(file, dataType);
          });
        }

        // $.each(this.files, function (key, file) {
        //     Profile.ajax.uploadUserDocument(file, dataType);
        // });

        $input.remove();
      }).hide();
      $(document.body).append($input);
      $input.click();
    }).on('click', '.upload-user-photo-btn', function (event) {
      event.preventDefault();
      var $input = $('<input type="file" accept=".webp, .png, .jpg, .jpeg, .pdf, .HEIC">').on('change', function () {
        // $.each(this.files, function (key, file) {
        //     Profile.ajax.uploadUserPhoto(file);
        // });

        var preloderCount = false;
        var fileNmame = this.files[0];
        var fileNameExt = fileNmame.name.substr(fileNmame.name.lastIndexOf('.') + 1);
        if (fileNameExt == "heic" || fileNameExt == "HEIC") {
          var thisInput = this;
          preloderCount = true;
          Main.preloaderProfilePopUp(event, preloderCount);
          heic2any({
            blob: fileNmame,
            toType: "image/jpeg",
            quality: 0.5
          }).then(function (result) {
            var container = new DataTransfer();
            var fileJpeg = new File([result], fileNmame.name + ".jpg", {
              type: "image/jpeg",
              lastModified: new Date().getTime()
            });
            container.items.add(fileJpeg);
            $.each(thisInput.files, function (key, fileJpeg) {
              console.log('container.files[0]', container.files[0]);
              Profile.ajax.uploadUserPhoto(container.files[0]);
            });
          })["catch"](function (x) {
            // console.log('erro-1', x.code);
            // console.log('erro-2', x.message);
            // console.log('x', x);
          });
        } else {
          $.each(this.files, function (key, file) {
            Profile.ajax.uploadUserPhoto(file);
          });
        }
        $input.remove();
      }).hide();
      $(document.body).append($input);
      $input.click();
    }).on('click', '.crop-user-photo-btn', function (event) {
      event.preventDefault();
      Profile.initUserPhotoCropper(true);
      Main.showPreloader($(this));
      setTimeout(function () {
        location.reload();
      }, 1000);
    }).on('input change paste', '.account-change-password', function (event) {
      event.preventDefault();
      Profile.stateChangePasswordButton();
    }).on('click', '#account-change-password-button', function (event) {
      event.preventDefault();
      var accountOldPassword = $('#old-password');
      var accountNewPassword = $('#new-password');
      var accountNewConfirmPassword = $('#confirm-password');
      var accountChangePasswordButton = $(this);
      Main.showPreloader(accountChangePasswordButton);
      Profile.ajax.changePassword(accountOldPassword, accountNewPassword, accountNewConfirmPassword, accountChangePasswordButton);
    }).on('click', '.open-delete-account-popup', function (event) {
      event.preventDefault();
      $('.popup-cant-delete').css('display', 'flex');
    }).on('click', '.close-delete-account-popup', function (event) {
      event.preventDefault();
      $('.popup-cant-delete').css('display', 'none');
    }).on('click', '#delete-account', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      Profile.ajax.deleteAccount($(this));
    }).on('click', '.open-user-photo-popup', function (event) {
      event.preventDefault();
      document.querySelector('body').classList.add('body-hidden');
      Profile.ajax.openUserPhotoPopup();
    }).on('keydown', '[name="profile_city"], [name="payout_city"]', function (event) {
      if (event.key.match(/[0-9]/)) return event.preventDefault();
    }).on('input paste', '[name="profile_city"], [name="payout_city"]', function () {
      $(this).val($(this).val().replace(/[0-9]/g, ""));
    }).on('keydown', '[name="tax_number"]', function (event) {
      if (event.key.match(/[0-9]/)) return event.preventDefault();
    }).on('input paste', '[name="tax_number"]', function () {
      $(this).val($(this).val().replace(/[0-9]/g, ""));
    }).on('click', '.reviews__btn--from', function (event) {
      event.preventDefault();
      $('.reviews__btn').removeClass('active');
      $(this).addClass('active');
      Profile.ajax.getReviewsFrom();
    }).on('click', '.reviews__btn--for', function (event) {
      event.preventDefault();
      $('.reviews__btn').removeClass('active');
      $(this).addClass('active');
      Profile.ajax.getReviewsFor();
    }).on('click', '#getCroppImg', function (event) {
      event.preventDefault();
      var getIdImg = $("#image-cropper");
      getIdImg.cropper('getCroppedCanvas', {
        aspectRatio: 1,
        viewMode: 1
      });
      document.getElementById('getCroppImg').src = getIdImg.cropper('getCroppedCanvas').toDataURL();
    }).on('change', 'form[data-type="24"] input', function (event) {
      event.preventDefault();
      Profile.collectServicesData();
    }).on('change', '.change-notification-channel', function (event) {
      $('.save-notification-channel').click();
    }).on('click', '.edit-image__delete', function (event) {
      event.preventDefault();
      Profile.ajax.removeUserPhoto($(this).attr('date-id'));
    }).on('click', 'button#download-archive-with-invoices', function (event) {
      event.preventDefault();
      Main.showPreloader($(this));
      Profile.ajax.downloadArchiveWithInvoices($(this));
    }).on('click', 'button.profile-proposals-tab', function (event) {
      event.preventDefault();
      var id = $(this).attr('data-id');
      $('.profile-proposals-tab').removeClass('active');
      $(this).addClass('active');
      $('.profile-services-content').hide();
      $(".profile-services-content[id=\"".concat(id, "\"]")).show();
    }).on('click', '.remove-find-task-options', function (event) {
      event.preventDefault();
      Profile.ajax.removeFindTaskOptions();
    }).on('click', '.turn-off-auto-translations', function (event) {
      event.preventDefault();
      Profile.ajax.turnOffAutoTranslations($(this));
    }).on('click', '.turn-on-auto-translations', function (event) {
      event.preventDefault();
      Profile.ajax.activateAutoTranslations($(this));
    }).on('click', '.show-pending-external-reviews', function (event) {
      event.preventDefault();
      $('.hide-pending-external-reviews').closest('.pending-review').css('display', 'flex');
      $('.reviews--list').css('display', 'flex');
      $(this).closest('.pending-review').css('display', 'none');
    }).on('click', '.hide-pending-external-reviews', function (event) {
      event.preventDefault();
      $('.show-pending-external-reviews').closest('.pending-review').css('display', 'flex');
      $('.reviews--list').css('display', 'none');
      $(this).closest('.pending-review').css('display', 'none');
    }).on('click', '.approve-external-reviews', function (event) {
      event.preventDefault();
      if ($(this).attr('data-error')) {
        Notify.successfulNotification($(this).attr('data-error'));
      } else {
        var hash = $(this).closest('.reviews--item').attr('data-hash');
        $('.approve-review--popup').attr('data-hash', hash).addClass('active');
      }
    }).on('click', '.reject-external-reviews', function (event) {
      event.preventDefault();
      var hash = $(this).closest('.reviews--item').attr('data-hash');
      $('.reject-review--popup').attr('data-hash', hash).addClass('active');
    }).on('click', '.approve-review--popup-approve-button', function (event) {
      event.preventDefault();
      var hash = $(this).closest('.approve-review--popup').attr('data-hash');
      Profile.ajax.approveExternalReview(hash);
    }).on('click', '.reject-review--popup-approve-button', function (event) {
      event.preventDefault();
      var hash = $(this).closest('.reject-review--popup').attr('data-hash');
      Profile.ajax.rejectExternalReview(hash);
    }).on('click', '.close-external-popups', function (event) {
      event.preventDefault();
      $(this).closest('.active').removeClass('active');
    }).on('click', '.open-external-review-popup', function (event) {
      event.preventDefault();
      $('.' + $(this).attr('data-class')).addClass('active');
    }).on('click', 'button.copy-link-for-external-reviews', function (e) {
      e.preventDefault();
      var notify = $(this).attr('data-notify');
      var data = $('input.copy-link-for-external-reviews').val();
      var input = $("<input>");
      $("body").append(input);
      input.val(data).select();
      document.execCommand("copy");
      input.remove();
      Notify.successfulNotification(notify);
    }).on('click', '#upload-more-profile-reviews', function (e) {
      e.preventDefault();
      var userID = $(this).attr('data-user-id');
      var typeFrom = $(this).attr('data-type-from');
      var page = $(this).attr('data-page');
      var owner = $(this).attr('data-owner');
      Main.showPreloader($(this));
      Profile.ajax.uploadMoreReviews(userID, typeFrom, page, owner);
    }).on('click', '.open-user-billing-details-popup', function (e) {
      e.preventDefault();
      $('.download-offer-popup').find('form').attr('data-type', FORM_TYPE_PROFILE_CLIENT_PAYOUT_METHOD_SUBSCRIPTION);
      $('.download-offer-popup').addClass('active');
    }).on('click', '.open-payments-plan-block', function (e) {
      e.preventDefault();
      if ($(this).text() == 'Selected') {
        $('#plans-payment-page').html('');
        Profile.isSelected = 0;
        $(this).text('Choose plan');
      } else {
        Profile.isSelected = 1;
        $('.open-payments-plan-block').text('Choose plan');
        $(this).text('Selected');
        var autoRenew = parseInt($(this).attr('data-type')) === 1 ? 0 : $(this).closest('.choose-plan-card').find('.switch').is(':checked') ? 1 : 0;
        var plan = $(this).attr('data-type');
        var pMethod = 1;
        var amount = $(this).attr('data-amount');
        var count = parseInt($(this).attr('data-type')) === 1 ? $('.counter-data').text().trim() : 0;
        Profile.ajax.openPaymentPlanBlock($(this), autoRenew, plan, pMethod, amount, count);
      }
    }).on('click', '.cancel-subscription', function (e) {
      e.preventDefault();
      Main.showPreloader($(this));
      Profile.ajax.cancelPlan($(this));
    }).on('click', '.open-billing-history', function (e) {
      e.preventDefault();
      // Main.showPreloader($(this));

      setTimeout(function () {
        $('.billing-history--popup').addClass('active');
        // Main.hidePreloader($(this));
      }, 1000);
    }).on('click', '.calculator-item-add-count-plus', function (e) {
      e.preventDefault();
      var count = parseInt($('.counter-data').text());
      $('.calculator-item-add-count-minus').removeClass('disabled');
      if (count > 99) {
        $(this).addClass('disabled');
      } else {
        $('.counter-data').text(count + 1);
        $('#plans-payment-page').html('');
        $('.open-payments-plan-block').text('Choose plan');
        $('.open-payments-plan-popup').text('Choose plan');
        $('.view-all-offers').prop('disabled', true);
      }
    }).on('click', '.calculator-item-add-count-minus', function (e) {
      e.preventDefault();
      var count = parseInt($('.counter-data').text());
      $('.calculator-item-add-count-plus').removeClass('disabled');
      if (count <= 1) {
        $(this).addClass('disabled');
      } else {
        $('.counter-data').text(count - 1);
        $('#plans-payment-page').html('');
        $('.open-payments-plan-block').text('Choose plan');
        $('.open-payments-plan-popup').text('Choose plan');
        $('.view-all-offers').prop('disabled', true);
      }
    }).on('click', '.stay-on-plan--closed', function (e) {
      e.preventDefault();
      $('.stay-on-plan--popup').removeClass('active');
    }).on('click', '.cancel-subscription-popup', function (e) {
      e.preventDefault();
      $('.stay-on-plan--popup').addClass('active');
    }).on('change', '.switch', function (e) {
      e.preventDefault();
      $('.open-payments-plan-popup').text('Choose plan');
      $('.view-all-offers').prop('disabled', true);
    });
  },
  resetPasswordSuccess: function resetPasswordSuccess() {
    if (Profile.resetPasswordSuccessfully) {
      setTimeout(function () {
        window.location.replace(Profile.resetPasswordSuccessfully);
      }, 2500);
    }
  },
  changePasswordSuccess: function changePasswordSuccess() {
    if (Profile.changePasswordSuccessfully) {
      setTimeout(function () {
        window.location.replace(Profile.changePasswordSuccessfully);
      }, 2500);
    }
  },
  autoRedirectAfterSofortCallbackFunction: function autoRedirectAfterSofortCallbackFunction() {
    if (Profile.autoRedirectAfterSofortCallbackUrl) {
      GA4.sendEvent();
      setTimeout(function () {
        window.location.replace(Profile.autoRedirectAfterSofortCallbackUrl);
      }, 3000);
    }
  },
  stateChangePasswordButton: function stateChangePasswordButton() {
    var accountOldPassword = $('#old-password');
    var accountNewPassword = $('#new-password');
    var accountNewConfirmPassword = $('#confirm-password');
    var accountChangePasswordButton = $('#account-change-password-button');
    if (accountOldPassword.val().length > 0 && accountNewPassword.val().length > 0 && accountNewConfirmPassword.val().length > 0) {
      accountChangePasswordButton.prop('disabled', false);
    } else {
      accountChangePasswordButton.prop('disabled', true);
    }
  },
  initDataPicker: function initDataPicker() {
    $("#profile_date, #changeInfoDateBirth").flatpickr({
      dateFormat: 'd.m.Y',
      enableTime: false,
      allowInput: false,
      maxDate: new Date().fp_incr(-6570),
      disableMobile: "true"
    });
  },
  initUserPhotoCropper: function initUserPhotoCropper() {
    var cropCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cropperOptions = {
      aspectRatio: 1,
      viewMode: 1,
      width: 160,
      height: 160,
      maxHeight: 160,
      maxWeight: 160
    };
    if (cropCheck) {
      var dataURLtoFile = function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {
          type: mime
        });
      };
      var getIdImg = $("#image-cropper");
      getIdImg.cropper('getCroppedCanvas', cropperOptions);
      var file = dataURLtoFile(getIdImg.cropper('getCroppedCanvas').toDataURL(), 'avater.png');
      Profile.ajax.uploadUserPhoto(file);
    } else {
      var crop = $('#image-cropper').cropper(cropperOptions);
    }
  },
  collectServicesData: function collectServicesData() {
    var input = $('[name="services"]');
    var checkbox = $('form[data-type="24"]').find("input:checked");
    var ids = "";
    var separator = ',';
    checkbox.map(function () {
      ids = ids + separator + $(this).attr('id');
    });
    console.log(ids + separator);
    input.val(checkbox.length > 0 ? ids + separator : '');
  },
  ajax: {
    obj: {},
    url: USER_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON');
    },
    openPaymentPlanBlock: function openPaymentPlanBlock($button, autoRenew, plan, pMethod, amount, count) {
      this.obj.method = 'getPaymentPlanData';
      this.obj.autoRenew = autoRenew;
      this.obj.plan = plan;
      this.obj.pMethod = pMethod;
      this.obj.amount = plan;
      this.obj.count = count;
      this.send(function (answer) {
        var plansBlock = $('#plans-payment-page');
        plansBlock.html(answer.html);
        Step.scrollToElement(plansBlock);
        Payment.init();
        ++Payment.initCounter;
      }, function (answer) {
        console.log('Error');
      });
    },
    fetchUserBillingInfoBlock: function fetchUserBillingInfoBlock() {
      this.obj.method = 'fetchUserBillingInfoBlock';
      this.send(function (answer) {
        $('#plans-billing-block-billing').html(answer.html);
      }, function (answer) {
        console.log('Error');
      });
    },
    cancelPlan: function cancelPlan($btn) {
      this.obj.method = 'cancelPlan';
      this.send(function (answer) {
        setTimeout(function () {
          window.location.reload();
        }, 750);
      }, function (answer) {
        Main.hidePreloader($btn);
      });
    },
    removeFindTaskOptions: function removeFindTaskOptions() {
      this.obj.method = 'removeFindTaskOptions';
      this.send(function (answer) {
        Notify.successfulNotification($('.remove-find-task-options').attr('data-text'));
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      }, function (answer) {
        console.log('Error');
      });
    },
    turnOffAutoTranslations: function turnOffAutoTranslations(button) {
      this.obj.method = 'turnOffAutoTranslations';
      this.send(function (answer) {
        Notify.successfulNotification($('.turn-off-auto-translations').attr('data-text'));
        if (button.hasAttr('data-action')) {
          if (button.attr('data-action') === '1') {
            if (Messages.isMiniChat) {
              Messages.ajax.openMiniChatViaHash(Messages.chatID);
            } else {
              $('div.chat__list__item.active').click();
            }
          }
        } else {
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        }
      }, function (answer) {
        console.log('Error');
      });
    },
    activateAutoTranslations: function activateAutoTranslations(button) {
      this.obj.method = 'activateAutoTranslations';
      this.send(function (answer) {
        Notify.successfulNotification($('.turn-on-auto-translations').attr('data-text'));
        if (button.hasAttr('data-action')) {
          if (button.attr('data-action') === '1') {
            if (Messages.isMiniChat) {
              Messages.ajax.openMiniChatViaHash(Messages.chatID);
            } else {
              $('div.chat__list__item.active').click();
            }
          }
        } else {
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        }
      }, function (answer) {
        console.log('Error');
      });
    },
    openUserPhotoPopup: function openUserPhotoPopup() {
      this.obj.method = 'openUserPhotoPopup';
      this.obj.type = $('#upload-user-photo').attr('data-type');
      this.send(function (answer) {
        setTimeout(function () {
          $('#upload-user-photo').css('display', 'flex').html(answer.html);
          Profile.initUserPhotoCropper();
        }, 100);
      }, function (answer) {
        console.log('Error with upload photo');
      });
    },
    getReviewsFrom: function getReviewsFrom() {
      this.obj.method = 'getReviewsFrom';
      this.send(function (answer) {
        $('#reviews').html(answer.html);
      }, function (answer) {
        console.log('Error with upload photo');
      });
    },
    getReviewsFor: function getReviewsFor() {
      this.obj.method = 'getReviewsFor';
      this.send(function (answer) {
        $('#reviews').html(answer.html);
      }, function (answer) {
        console.log('Error with upload photo');
      });
    },
    changePassword: function changePassword(accountOldPassword, accountNewPassword, accountNewConfirmPassword, accountChangePasswordButton) {
      this.obj.method = 'changePassword';
      this.obj.oldPassword = accountOldPassword.val();
      this.obj.newPassword = accountNewPassword.val();
      this.obj.confirmPassword = accountNewConfirmPassword.val();
      this.send(function (answer) {
        Notify.successfulNotification(answer.notify);
        Main.hidePreloader(accountChangePasswordButton, true);
        accountOldPassword.val('');
        accountNewPassword.val('');
        accountNewConfirmPassword.val('');
        accountChangePasswordButton.prop('disabled', true);
      }, function (answer) {
        $.each(answer.errors, function (id, value) {
          Step.showErrors(id, value);
        });
        Main.hidePreloader(accountChangePasswordButton);
      });
    },
    uploadUserDocument: function uploadUserDocument(file, type) {
      var data = new FormData();
      data.append('method', 'uploadUserDocument');
      data.append('type', type);
      data.append('file', file);
      $.ajax({
        url: USER_URL,
        type: 'POST',
        data: data,
        contentType: false,
        processData: false,
        success: function success(answer) {
          $("div.personal-info-form__files[data-type=\"".concat(answer.type, "\"]")).attr('data-status', 1).html(answer.html);
        }
      });
    },
    uploadUserPhoto: function uploadUserPhoto(file) {
      var data = new FormData();
      data.append('method', 'uploadUserPhoto');
      data.append('file', file);
      data.append('type', $('#upload-user-photo').attr('data-type'));
      $.ajax({
        url: USER_URL,
        type: 'POST',
        data: data,
        contentType: false,
        processData: false,
        success: function success(answer) {
          document.querySelector('body').classList.add('body-hidden');
          $('#upload-user-photo').css('display', 'flex').html(answer.html);
          setTimeout(function () {
            Profile.initUserPhotoCropper();
          }, 100);
          $('.user__photo-img').find('img').attr('src', $('#image-cropper').attr('src'));
          $('.header-account__avatar').find('img').attr('src', $('#image-cropper').attr('src'));
        }
      });
    },
    removeUserPhoto: function removeUserPhoto(id) {
      this.obj.method = 'removeUserPhoto';
      this.obj.id = id;
      this.send(function (answer) {
        Profile.ajax.openUserPhotoPopup();
        $('.user__photo-img').find('img').attr('src', DEFAULT_USER_PHOTO);
        $('.header-account__avatar').find('img').attr('src', DEFAULT_USER_PHOTO);
      }, function (answer) {
        console.error('Error');
      });
    },
    deleteAccount: function deleteAccount(btn) {
      var _$$val, _$$val2;
      this.obj.method = 'deleteAccount';
      this.obj.reason = (_$$val = $('[name="delete-account-reason"]').val()) !== null && _$$val !== void 0 ? _$$val : 0;
      this.obj.description = (_$$val2 = $('[name="delete-account-description"]').val()) !== null && _$$val2 !== void 0 ? _$$val2 : '';
      this.send(function (answer) {}, function (answer) {
        Main.hidePreloader(btn);
        $.each(answer.errors, function (key, value) {
          if (key === 'mainError') {
            $('#main-error').show().html(value);
          } else {
            btn.closest('form').find("[name=\"".concat(key, "\"]")).closest('div').find('.error').show().html(value);
          }
        });
      });
    },
    downloadArchiveWithInvoices: function downloadArchiveWithInvoices(btn) {
      this.obj.method = 'downloadArchiveWithInvoices';
      this.send(function (answer) {
        window.open(answer.link);
        Main.hidePreloader(btn);
      }, function (answer) {
        if (answer.needClientInfo) {
          $('.download-offer-popup').find('form').attr('data-type', FORM_TYPE_PROFILE_CLIENT_PAYOUT_METHOD_INVOICES);
          $('.download-offer-popup').addClass('active');
        }
        Main.hidePreloader(btn);
      });
    },
    approveExternalReview: function approveExternalReview(hash) {
      this.obj.method = 'approveExternalReview';
      this.obj.hash = hash;
      this.send(function (answer) {
        $('.approve-review--popup').removeClass('active');
        $('#user-approve-external-review').addClass('active');
        $('.reviews__btn--for').click();
        $(".reviews--item[data-hash=\"".concat(hash, "\"]")).remove();
        var itemsCount = $('.reviews--item').length;
        $('.dashboard__profile-r').find('.counter').find('span').text(itemsCount);
        if (itemsCount === 0) {
          $('.pending-review').remove();
          $('.dashboard__profile-r').find('.counter').remove();
        }
      }, function (answer) {
        $('.pending-review').remove();
        $(".reviews--item").remove();
      });
    },
    uploadMoreReviews: function uploadMoreReviews(userID, type, page, owner) {
      this.obj.method = 'uploadMoreReviews';
      this.obj.userID = userID;
      this.obj.type = type;
      this.obj.page = page;
      this.obj.owner = owner;
      this.send(function (answer) {
        var $button = $('#upload-more-profile-reviews');
        if (parseInt(answer.reviewItems) > 0) {
          $('.reviews__items').append(answer.html);
        }
        if (parseInt(answer.reviewItems) < 10) {
          $button.remove();
        } else {
          $button.attr('data-page', parseInt($button.attr('data-page')) + 1);
        }
        Main.hidePreloader($button);
      }, function () {});
    },
    rejectExternalReview: function rejectExternalReview(hash) {
      this.obj.method = 'rejectExternalReview';
      this.obj.hash = hash;
      this.send(function (answer) {
        $('.reject-review--popup').removeClass('active');
        $('#user-reject-external-review').addClass('active');
        $(".reviews--item[data-hash=\"".concat(hash, "\"]")).remove();
        var itemsCount = $('.reviews--item').length;
        $('.dashboard__profile-r').find('.counter').find('span').text(itemsCount);
        if (itemsCount === 0) {
          $('.pending-review').remove();
          $('.dashboard__profile-r').find('.counter').remove();
        }
      }, function (answer) {});
    }
  }
};